import { render } from "./Proveedor_Recolecciones.vue?vue&type=template&id=2f87dea2"
import script from "./Proveedor_Recolecciones.vue?vue&type=script&lang=js"
export * from "./Proveedor_Recolecciones.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__